import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {API_END_POINT} from '@shared/utils/api-end-points';
import {Observable} from 'rxjs';
import {HelpArticle, HelpStatus} from '@shared/models/contextual-help.model';

/**
 * Abstraction for retrieving contextual help content. The current implementation calls the
 * Harmony help API, which serves the validated JSON package cached on the server. A future
 * remote/CDN provider can replace it without touching consumers.
 */
export abstract class HelpContentProvider {
  abstract getArticle(identifier: string, locale: string): Observable<HelpArticle>;

  abstract getStatus(): Observable<HelpStatus>;
}

@Injectable({providedIn: 'root'})
export class ApiHelpProvider extends HelpContentProvider {
  private readonly endpoint = API_END_POINT.common.help;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Help identifiers contain dots, so they travel as a query-string value rather than a path
   * segment (IIS would otherwise treat the trailing segment as a file extension).
   */
  getArticle(identifier: string, locale: string): Observable<HelpArticle> {
    let params = new HttpParams().set('identifier', identifier);
    if (locale) {
      params = params.set('locale', locale);
    }

    return this.http.get<HelpArticle>(`${this.endpoint}GetArticle`, {params});
  }

  getStatus(): Observable<HelpStatus> {
    return this.http.get<HelpStatus>(`${this.endpoint}GetStatus`);
  }
}
